/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { OverFlowMenuUI } from "components/hud/OverFlowMenuUI";
import { contextMenuManager } from "contextMenuManager";
import { contextMenuTriggerType } from "dc-preview-utils/src/Constants/enums";
import { showHUD } from "selectors/hudSelectors";
import { isContextMenuVisible, getContextMenuTriggerType } from "selectors/contextMenuSelectors";
import { getShouldUseModernViewer } from "selectors/appSelectors";

const mapStoreToProps = (stores, ownProps) => ({
  triggerContextMenu: (eventObj, extraParams = {}) =>
    contextMenuManager.triggerContextMenu(
      eventObj,
      stores,
      extraParams,
      contextMenuTriggerType.HUD_OVERFLOW_BUTTON_CLICK
    ),
  isHudOverFlowMenuVisible:
    isContextMenuVisible(stores) &&
    getContextMenuTriggerType(stores) === contextMenuTriggerType.HUD_OVERFLOW_BUTTON_CLICK,
  clearMenuItems: () => contextMenuManager.clearMenuItems(stores),
  showHUD: showHUD(stores),
  useModernViewer: getShouldUseModernViewer(stores)
});

const OverFlowMenuContainer = inject(mapStoreToProps)(OverFlowMenuUI);

export { OverFlowMenuContainer };
